// @ts-check

export class ReportItem {
  /**
   * @param {any} data
   */
  constructor(data) {
    this.id = data.id;
    this.studyuuid = data.studyuuid;
    this.patient = data.patient;
    this.filename = data.filename;
    this.uploadtime = data.uploadtime;
  }
}

export default class StudyReport {
  /**
   * @param {any} data
   */
  constructor(data) {
    this.existe = data.existe;
    this.nombre = data.nombre;
    this.counter = data.counter;
    this.list = (data.list || []).map(
      (/** @type {any} */ item) => new ReportItem(item),
    );
  }
}
